// export const SERVER = "http://192.168.29.82:7037"
// export const SERVER = "http://192.168.29.54:7090"
// export const SERVER = "http://localhost:7037"
// export const SERVER = "http://localhost:7090"

// export const SERVER = "https://marengo-portal.weaddo.live";
export const SERVER = "https://portalbackend.marengoasiahospitals.com";
export const POLICY_BASE_URL = "https://patientapp.marengoasia.com/";
export const imgUrl = () =>
  "https://patientapp.marengoasia.com/Files/Doctor";

export const Specialty = () =>
  "https://patientapp.marengoasia.com/Files/Specialisation";

export const ProfilePic =
  "https://patientapp.marengoasia.com/Files/ProfilePic/";
